module.exports = __webpack_public_path__ + "img/某白药联合巨头公司的成功营销.ef957d44.png";